module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration011.5b23e2b2.webp";